import { styled } from '@mui/material/styles';

export const Container = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '90vh'
}));

export const Animation = styled('div')(({ theme }) => ({
  width: '120px',
  height: '120px',
  [theme.breakpoints.up('sm')]: {
    width: '200px',
    height: '200px'
  }
}));
